/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:54
 */
import Column from './Column';
import 'select2';

class MultiDropdownColumn extends Column {

  constructor(params) {
    super(params);
    this.init();
  }

  select2AjaxConfig() {
    const select = this.root.querySelector('.js-column-value');

    if (!select.dataset.optionsUrl) {
      return null;
    }

    return {
      delay: 200,
      url: select.dataset.optionsUrl,
      processResults: function (data) {
        return {
          results: data.results.map((result) => ({
            id: result.value,
            text: result.name,
          })),
          pagination: data.pagination,
        };
      }
    }
  }

  init() {
    const select = this.root.querySelector('.js-column-value');
    const placeholder = "Choose an option";

    $(select).select2({
      ajax: this.select2AjaxConfig(),
      allowClear: true,
      containerCssClass: select.getAttribute('class'),
      dropdownAutoWidth: true,
      dropdownCssClass: 'dropdown-menu dropdown-menu-right dropdown-menu-sm show',
      placeholder: placeholder,
      width: '100%',
    });
  }

}

export default MultiDropdownColumn;



// WEBPACK FOOTER //
// ./resources/assets/js/columns/MultiDropdownColumn.js